import { Modal } from '@mantine/core';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../elements/Button/Button';
import ApproveManualActivation from '../../forms/ApproveManualActivationForm';
import styles from './styles.scoped.css';

export default function ModalManualLoggingActivation({
  type,
  data,
  onClose,
  reason,
  handleSubmit,
  open,
  // onOpenModalChangePassword = () => {},
  // values = {}
}) {
  const content = {
    'approve': {
      title: 'Persetujuan Pencatatan Manual',
      subtitle: (
        <>
          Apakah Anda yakin untuk menyetujui pengajuan aktivasi pencatatan manual {' '}
          <strong>{data?.data?.storeName}</strong>?
        </>
      ),
      component: <ApproveManualActivation
        handleClose={onClose}
        handleSubmit={handleSubmit}
        requestId={data?.data?.requestId}
      />,
      footer: null
      //   footer: (
      //     <div className={styles.modalAction}>
      //       <Button onClick={onClose}>Batal</Button>
      //       <Button onClick={handleSubmit} ">
      //         Kirim
      //       </Button>
      //     </div>
      //   ),
    },
    'reject': {
      title: 'Menolak Aktivasi Pencatatan Manual',
      subtitle: (
        <>
          Apakah Anda yakin untuk tolak pengajuan aktivasi pencatatan manual {' '}
          <strong>{data?.data?.storeName}</strong>?
        </>
      ),
      component: <ApproveManualActivation
        handleClose={onClose}
        handleSubmit={handleSubmit}
        requestId={data?.data?.requestId}
      />,
      footer: null
      //   footer: (
      //     <div className={styles.modalAction}>
      //       <Button onClick={onClose}>Batal</Button>
      //       <Button onClick={handleSubmit} ">
      //         Kirim
      //       </Button>
      //     </div>
      //   ),
    },
    'reason': {
      title: 'Alasan Penolakan',
      subtitle: reason,
      component: null,
      footer: (
        <div className={styles.modalAction}>
          <Button onClick={onClose}>Tutup</Button>
        </div>
      ),
    }
  };

  return (
    <Modal
      centered
      // className={styles.modal}
      //   lastUpdate={lastUpdate}
      onClose={onClose}
      opened={open}
      size={'md'}
      withCloseButton={false}
    >
      <div className={styles.modalContent}>
        <h4>{content[type]?.title}</h4>
        <p>{content[type]?.subtitle}</p>
        {content[type]?.component}
      </div>
      {content[type]?.footer}
    </Modal>
  );
}


ModalManualLoggingActivation.propTypes = {
  data: PropTypes.object,
  handleSubmit: PropTypes.func,
  onClose: PropTypes.func,
  onOpenModalChangePassword: PropTypes.func,
  open: PropTypes.bool,
  reason: PropTypes.string,
  type: PropTypes.oneOf([
    'approve',
    'reject',
    'reason',
  ]),
  values: PropTypes.object,
};

